import { render, staticRenderFns } from "./CalendarOpenings.vue?vue&type=template&id=18a99e30&scoped=true"
import script from "./CalendarOpenings.vue?vue&type=script&lang=js"
export * from "./CalendarOpenings.vue?vue&type=script&lang=js"
import style0 from "./CalendarOpenings.vue?vue&type=style&index=0&id=18a99e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a99e30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCard,VCol,VIcon,VList,VListItem,VListItemTitle,VMenu,VRow})
